import React, { Component } from 'react';
import CSSTransitionGroup from 'react-transition-group/CSSTransitionGroup';
import { Link } from 'react-router-dom';
import get from 'lodash.get';
import cn from 'classnames';

import DataStore from '../../stores/DataStore';
import WorkHelmet from './Helmet';

import Summary from '../../components/Summary/Summary';
import Basic from '../../components/Basic/Basic';
import Browser from '../../components/Browser/Browser';
import Laptop from '../../components/Laptop/Laptop';
import TabletLandscape from '../../components/TabletLandscape/TabletLandscape';
import TabletPortrait from '../../components/TabletPortrait/TabletPortrait';
import Mobile from '../../components/Mobile/Mobile';

import styles from './work.css';

class Work extends Component {

	constructor(props) {
    super(props);
  }

  componentWillMount() {
  	this.match = this.props.match.params.project;
    this.data = DataStore.getWorkBySlug(this.match);
  }

	render() {
		const {
      next_post,
      content
    } = this.data;

		const {
      theme_primary_color,
      theme_secondary_color,
      work_layout,
      work_link
    } = this.data.acf;

    const studio = get(this.data, 'work_studio[0].name');
    const role = get(this.data, 'work_role[0].name');

		const themeStyle = {
			backgroundColor: theme_primary_color,
			color: theme_secondary_color
		};

		const nextPostStyle = {
			backgroundColor: next_post.theme_color
		};

		return (
			<section style={themeStyle} className={styles.wrapper}>
				<WorkHelmet title={this.data.title.rendered} />

        <div className={styles.content}>
		    	<Link className={styles.closeLink} to="/">
		    		<div className={styles.closeButton} />
		    	</Link>
		    	<Summary theme={styles} data={content.rendered} />

          <ul className={styles.list}>
            <li className={styles.listItem}>
              <strong className={styles.title}>Studio</strong> {studio}
            </li>
            <li className={styles.listItem}>
              <strong className={styles.title}>Role</strong> {role}
            </li>
            { work_link !== '' ?
            <li className={styles.listItem}>
              <a className={styles.link} rel="noopener noreferrer" target="_blank" href={`http://${work_link}`}>
                <strong className={styles.title}>http://</strong>{work_link}
              </a>
            </li>
              : null }
          </ul>

        { work_layout.length ?
          <section className={styles.workContent}>
          {
            work_layout.map((workItem, index) =>
              <div className={styles.workItem} key={index}>
                { get(workItem, 'layout_type[0].acf_fc_layout') == 'basic' ?
                  <Basic data={workItem} /> : null
                }
                { get(workItem, 'layout_type[0].acf_fc_layout') == 'browser' ?
                  <Browser data={workItem} /> : null
                }
                { get(workItem, 'layout_type[0].acf_fc_layout') == 'laptop' ?
                  <Laptop data={workItem} /> : null
                }
                { get(workItem, 'layout_type[0].acf_fc_layout') == 'tablet landscape' ?
                  <TabletLandscape data={workItem} /> : null
                }
                { get(workItem, 'layout_type[0].acf_fc_layout') == 'tablet portrait' ?
                  <TabletPortrait data={workItem} /> : null
                }
                { get(workItem, 'layout_type[0].acf_fc_layout') == 'mobile' ?
                  <Mobile data={workItem} /> : null
                }
              </div>
            )
          }
          </section>
        : null }

		    </div>
        <Link className={styles.colorLink} to={`/work/${next_post.title}`}>
          <div style={nextPostStyle} className={styles.colorBar} />
        </Link>
		   </section>
		);
	}
}

export default Work;



// WEBPACK FOOTER //
// ./src/views/Work/Work.js